var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.755,
    height: 11.729,
    viewBox: "0 0 16.755 11.729",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M1.755-2.21V-.953a.837.837,0,0,1-.838.838H.046A2.514,2.514,0,0,1-2.433,1.979,2.514,2.514,0,0,1-4.913-.116H-8.332a2.514,2.514,0,0,1-2.479,2.094A2.513,2.513,0,0,1-13.29-.116h-.873A.837.837,0,0,1-15-.953V-3.886a1.678,1.678,0,0,1,1.062-1.56l1.09-2.724a2.514,2.514,0,0,1,2.333-1.58h4.762a2.549,2.549,0,0,1,1.964.943l2.618,3.272a3.33,3.33,0,0,1,2.927,3.3ZM-10.515-8.074a.806.806,0,0,0-.778.526l-.793,1.987h2.951V-8.074Zm2.636,2.513h4.54L-5.1-7.76a.867.867,0,0,0-.655-.314H-7.879ZM-1.248-.116a1.42,1.42,0,0,0,.071-.419A1.257,1.257,0,0,0-2.433-1.791,1.257,1.257,0,0,0-3.69-.535a.925.925,0,0,0,.071.419A1.26,1.26,0,0,0-2.433.722,1.26,1.26,0,0,0-1.248-.116Zm-8.378,0a1.42,1.42,0,0,0,.071-.419,1.257,1.257,0,0,0-1.257-1.257A1.257,1.257,0,0,0-12.068-.535.925.925,0,0,0-12-.116a1.26,1.26,0,0,0,1.186.838A1.26,1.26,0,0,0-9.625-.116Z",
    transform: "translate(15 9.75)",
    fill: "#262532",
    opacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.cd323d212a79de8fdcc499716fda82ea.svg";
export { ForwardRef as ReactComponent };